// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editable-row-operations a[data-v-257a3262]{margin-right:8px}.editable-add-btn[data-v-257a3262]{margin-top:8px}", ""]);
// Exports
module.exports = exports;
